/* eslint-disable max-len */
import React from 'react'
import {connect} from 'react-redux'
// import Helpers from '../Helpers.js'

// Actions
import {storePayload} from '../actions/storePayload'
import {changeQuestion} from '../actions/changeQuestion2'
import {fetchSubSectionResponse} from '../actions/fetchSubSectionResponse.js'
import {fetchSectionResponse} from '../actions/fetchSectionResponse.js'
import FormFooter from './FormFooter.js'

// Components
// import {Button, Icon} from '@lazarusai/forms-ui-components'

// Styles
import '../styles/FormControl.css'

function FormControl(props) {
  // const [isDownloadDisabled, setIsDownloadDisabled] = useState(true)
  const {
    prompt1Response,
    selectedSectionIndex,
    selectedSectionName,
    selectedSubSectionIndex,
    selectedSubSectionName,
    currentPqId,
    currentPqIdIndex,
    currentUfqIdIndex,
    isReview,
    isSubSectionReadyForReview,
    isLastQInView,
    isSkip,
    isResourcesPage,
    // eslint-disable-next-line no-unused-vars
    time,
  } = props
  // const selectedSectionName = Object.keys(prompt1Response)[selectedSectionIndex]
  // const selectedSubSectionName =
  //   Object.keys(prompt1Response[selectedSectionName])[selectedSubSectionIndex]

  // useEffect(() => {
  //   if (props.documents) {
  //     const isDownloadDisabled = props.documents?.[selectedSectionName] ? false : true
  //     setIsDownloadDisabled(isDownloadDisabled)
  //   }
  // }, [time, props.documents])

  function onClickChat() {
    // console.log('setting is chat showing', !props.isChatShowing)
    props.storePayload({
      isChatShowing: !props.isChatShowing,
    })
  }

  function onChangeQuestion(isNext) {
    let onChangeQuestionProps = {
      currentPqId,
      currentPqIdIndex,
      currentUfqIdIndex,
      prompt1Response,
      selectedSectionIndex,
      selectedSubSectionIndex,
      selectedSectionName,
      selectedSubSectionName,
      isReview,
      isSubSectionReadyForReview,
      isResourcesPage,
    }
    if (isNext) { // go forward
      if (isLastQInView) {
        props.storePayload({
          isSubSectionReadyForReview: true,
        })
        return
      }
      onChangeQuestionProps = {
        ...onChangeQuestionProps,
        newSubSectionIndex: selectedSubSectionIndex + 1,
        newPqIdIndex: currentPqIdIndex + 1,
        newUfqIdIndex: currentUfqIdIndex + 1,
        direction: 'forwards',
      }
    } else { // go back
      if (isReview) {
        props.storePayload({
          isReview: false,
        })
        return
      }
      onChangeQuestionProps = {
        ...onChangeQuestionProps,
        newSubSectionIndex: selectedSubSectionIndex - 1,
        newPqIdIndex: currentPqIdIndex - 1,
        newUfqIdIndex: currentUfqIdIndex - 1,
        direction: 'backwards',
      }
    }
    // console.log('here')
    props.changeQuestion(onChangeQuestionProps)
  }

  function onClickSubmit() {
    if (isReview) {
      props.storePayload({
        isLoading: true,
      })
      // To do: remove hardcoded index, make dynamic
      const isLastSubSection = selectedSubSectionIndex === 6
      if (isLastSubSection) {
        // props.storePayload({
        //   typeFormStep: 'section-review',
        // })
        props.fetchSubSectionResponse(true)
      } else {
        props.fetchSubSectionResponse(false)
      }
    }
  }

  return (
    <FormFooter
      btn1Text={
        isReview ?
          'Submit' :
          props.isResourcesPage ?
          'Skip this Step' :
          ''
      }
      onClickBtn1={
        isReview ?
          onClickSubmit :
          props.isResourcesPage ?
            () => onChangeQuestion(true) :
            null
      }
      onClickArrowUp={
        isSkip ?
          null :
          () => {
            onChangeQuestion(false)
          }
      }
      onClickArrowDown={
        isReview || isSubSectionReadyForReview ?
        null :
        () => {
          onChangeQuestion(true)
        }
      }
      onClickChat={onClickChat}
      theme={props.theme}
      style={{
        left: 'calc(2.625em + 20px)',
        width: 'calc(100% - (2.625em + 20px))',
        padding: 'var(--spacing-06, 24px) 20px',
      }}
    />
    // <footer
    //   className={`form-control ${isReview ? 'review-form-control' : ''}`}
    //   onClick={() => {
    //     if (props.isChatShowing) {
    //       props.storePayload({
    //         isChatShowing: false,
    //       })
    //     }
    //   }}
    // >
    //   {props.isReview &&
    //     <div>
    //       <Button
    //         style={{Maxwidth: '16.75em', fontSize: '16px'}}
    //         text={'Submit'}
    //         icon={
    //           <Icon
    //             icon='upload-outline'
    //             key='Submit'
    //           />
    //         }
    //         iconPosition='right'
    //         iconJustify='edge'
    //         theme={props.theme}
    //         onClick={onClickSubmit}
    //         className='btn-change'
    //       />
    //     </div>
    //   }
    //   <div className='two-btn-container'>
    //     {/* <button>
    //       Test this button to see if it disappears plzzzzzzzzzzzzzzzzzzzzzzzzzz
    //     </button> */}
    //     <Button
    //       style={{maxWidth: '10.5em', fontSize: '16px'}}
    //       text={''}
    //       icon={
    //         <Icon
    //           icon='arrow-ios-upward-outline'
    //           key='back'
    //         />
    //       }
    //       onClick={() => onChangeQuestion(false)}
    //       disabled={isSkip}
    //       theme={props.theme}
    //     />
    //     <Button
    //       style={{maxWidth: '10.5em', fontSize: '16px'}}
    //       text={''}
    //       icon={
    //         <Icon
    //           icon='arrow-ios-downward-outline'
    //           key='next'
    //         />
    //       }
    //       disabled={isReview || isSubSectionReadyForReview}
    //       onClick={() => onChangeQuestion(true)}
    //       theme={props.theme}
    //     />
    //   </div>
    //   <div className='two-btn-container'>
    //     <a
    //       href={
    //         props.documents?.[selectedSectionName]
    //       }
    //       download={selectedSectionName}
    //     >
    //       <Button
    //         style={{maxWidth: '16.8em'}}
    //         text={''}
    //         disabled={isDownloadDisabled}
    //         icon={
    //           <Icon
    //             icon='download-outline'
    //             key='back'
    //           />
    //         }
    //         theme={props.theme}
    //       />
    //     </a>
    //     <Button
    //       style={{maxWidth: '16.8em'}}
    //       text={''}
    //       icon={
    //         <Icon
    //           icon='message-square-outline'
    //           key='chat'
    //         />
    //       }
    //       onClick={() => {
    //         props.storePayload({
    //           isChatShowing: !props.isChatShowing,
    //         })
    //       }}
    //       theme={props.theme}
    //     />
    //   </div>
    // </footer>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  selectedSectionName: state.userReducer.selectedSectionName,
  selectedSectionIndex: state.userReducer.selectedSectionIndex,
  selectedSubSectionIndex: state.userReducer.selectedSubSectionIndex,
  selectedPath: state.userReducer.selectedPath,
  prompt1Response: state.userReducer.prompt1Response,
  currentPqId: state.userReducer.currentPqId,
  currentPqIdIndex: state.userReducer.currentPqIdIndex,
  currentUfqIdIndex: state.userReducer.currentUfqIdIndex,
  time: state.userReducer.time,
  isChatShowing: state.userReducer.isChatShowing,
  isReview: state.userReducer.isReview,
  documents: state.userReducer.documents,
  isSubSectionReadyForReview: state.userReducer.isSubSectionReadyForReview,
  isLastQInView: state.userReducer.isLastQInView,
  documents: state.userReducer.documents,
  isSkip: state.userReducer.isSkip,
  isResourcesPage: state.userReducer.isResourcesPage,
})

export default connect(
    mapStateToProps,
    {
      storePayload,
      changeQuestion,
      fetchSubSectionResponse,
      fetchSectionResponse,
    },
)(FormControl)
